import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Firestore, doc, docData } from '@angular/fire/firestore';
import { AuthService } from 'src/app/shared/services/auth.service';

type AdminSectionKey = 'demos' | 'topic-areas' | 'pending-files' | 'ads' | 'alerts' | 'users' | 'environments' | 'special-events';

@Component({
  standalone: false,
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.scss'],
})
export class AdminPanelComponent implements OnInit {
  selectedSection: AdminSectionKey = 'alerts';

  readonly menuItems: Array<{ key: AdminSectionKey; label: string }> = [
    { key: 'alerts', label: 'Prisma Alerts' },
    { key: 'users', label: 'Users' },
    { key: 'environments', label: 'Environments' },
    { key: 'ads', label: 'Ads' },
    { key: 'special-events', label: 'Special Events' },
    { key: 'pending-files', label: 'GitHub' },
    { key: 'topic-areas', label: 'Topic Areas' },
    { key: 'demos', label: 'Demos' },
  ];

  token = '';

  constructor(
    private authService: AuthService,
    private firestore: Firestore,
    private snackBar: MatSnackBar,
    private router: Router,
  ) {
    this.token = localStorage.getItem('token') || '';
  }

  ngOnInit(): void {
    if (!this.token) {
      this.showError('Missing auth token. Please sign in again.');
      this.router.navigate(['/sign-in']);
      return;
    }

    docData(doc(this.firestore, `users/${this.authService.userData.email}`))
      .subscribe((user: any) => {
        if (!this.isAdminUser(user)) {
          this.showError('Admin access required.');
          this.router.navigate(['/sign-in']);
        }
      });
  }

  private isAdminUser(user: any): boolean {
    if (!user) {
      return false;
    }

    return Boolean(
      user.isAdmin
      || user.admin
      || (typeof user.role === 'string' && user.role.toLowerCase() === 'admin')
      || (Array.isArray(user.roles) && user.roles.map((role: string) => role.toLowerCase()).includes('admin'))
    );
  }

  selectSection(key: AdminSectionKey): void {
    this.selectedSection = key;
  }

  private showError(message: string): void {
    this.snackBar.open(message, 'OK');
  }
}
